import { googleEndpoints } from '@playbooks/components/google/google-app';
import { OAuthRedirectBtn } from '@playbooks/components/oauth/oauth-redirect-btn';

const GoogleAuthBtn = ({
	referralCode = null,
	intent = 'authenticate',
	onNext,
	children = 'Continue with Google',
	...props
}) => {
	return (
		<OAuthRedirectBtn
			provider='Google'
			callbackType='onGoogle'
			storageKey='googleAuthorizationParams'
			variant='outline'
			size='lg'
			prevIcon={{ type: 'fab', icon: 'google' }}
			url={googleEndpoints.authorize}
			params={{ intent, referralCode }}
			popup
			onNext={onNext}
			className='w-full'
			{...props}>
			{children}
		</OAuthRedirectBtn>
	);
};

export { GoogleAuthBtn };
